module.exports = __webpack_public_path__ + "static/_colorbase_BL002-7084d330ae2f0f11cd386f5cd2de8134.jpg";